import React, { useEffect, useState } from 'react';
import { Alert, Button, Steps } from 'antd';
import Timer from 'react-compound-timer';
import OtpInput from 'react-otp-input';
import { useDispatch, useSelector } from 'react-redux';
import { CHECK_MOBILE, LOGGED_IN_SUCCESS, SEND_OTP, UPDATE_MOBILE, VERIFY_OTP } from '../../../actions/types';
import { isValidMobile, openNotificationInToast } from '../../../utilities';
import ModalBox from '../../../components/common/ModalBox';
import { getAccessTokenFromLocalStorage } from '../../../services/backendServices';
import PhoneNumberInput from '../../../components/common/PhoneNumberInput';

const timer = 30000;

function ChangeNumberModal(props) {
  const { isModalVisible, setIsModalVisible, userDetails } = props;
  const authentications = useSelector((state) => state.authentications);
  const { domainDetails } = useSelector((state) => state.listings);
  const [currentStep, setCurrentStep] = useState(0);
  const [otp, setOtp] = useState('');
  const [endTimer, setEndTimer] = useState(false);
  const [showAlert, setShowAlert] = useState({ show: false, message: '' });
  const [mobileUpdateStatus, setMobileUpdateStatus] = useState('');
  const [isUpdated, setIsUpdated] = useState(false);
  const [mobileError, setMobileError] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const dispatch = useDispatch();

  const { Step } = Steps;

  const verifyOtp = () => {
    dispatch({
      type: VERIFY_OTP,
      payload: {
        mobileNumber: phoneNumber.nationalNumber,
        otp: otp,
      },
    });
  };

  useEffect(() => {
    if (otp.length === 6) {
      verifyOtp();
    }
  }, [otp, showAlert.show]);

  useEffect(() => {
    if (authentications.checkMobile.isUser === 'userExist') {
      setShowAlert({ show: true, message: 'The number already exists. Please use a different number or contact us' });
    } else if (authentications.checkMobile.isUser === 'newUser') {
      updateMobile();
    }
  }, [authentications.checkMobile.isUser]);

  useEffect(() => {
    if (authentications.otpVerificationStatus === 'failed') {
      setShowAlert({ show: true, message: 'Please enter correct OTP' });
    } else if (authentications.otpVerificationStatus === 'success') {
      openNotificationInToast('success', 'Mobile Updated!', 'Mobile numbner has been updated!');
      setMobileUpdateStatus('');
      setIsUpdated(false);
      setCurrentStep(0);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      if (typeof props.mobileChangeStatus === 'function') {
        props.mobileChangeStatus(true, 'Success');
      }
      setIsModalVisible(false);
    }
  }, [authentications.otpVerificationStatus]);

  useEffect(() => {
    if (authentications.updateMobileStatus === 'success') {
      sendOtp();
    } else if (authentications.updateMobileStatus === 'success') {
      openNotificationInToast('error', 'Mobile Updated!', 'There are some issue for updating mobile number, Check back later!');
    }
  }, [authentications.updateMobileStatus]);

  const checkMobile = () => {
    if (!isValidMobile(phoneNumber.nationalNumber)) {
      setMobileError('Please enter valid mobile number!');
      return false;
    } else {
      dispatch({
        type: CHECK_MOBILE,
        payload: {
          mobileNum: phoneNumber.nationalNumber,
        },
      });
      setMobileError('');
    }
  };

  const updateMobile = () => {
    const payload = {
      accessToken: JSON.parse(getAccessTokenFromLocalStorage()),
      mobileNum: phoneNumber.nationalNumber,
    };
    dispatch({
      type: UPDATE_MOBILE,
      payload: payload,
    });
  };

  const sendOtp = () => {
    setEndTimer(false);
    getEndTimer();
    attemptStatus();
    dispatch({
      type: SEND_OTP,
      payload: {
        mobileNumber: phoneNumber.nationalNumber,
        site: domainDetails && domainDetails.orgType === 'certifier' ? 'microsite' : 'docpro',
        countrySortName: authentications.mobileDetails.country,
        organizationId: domainDetails.id
      },
    });
    setCurrentStep(1);
  };

  const getEndTimer = () => {
    setTimeout(() => {
      setEndTimer(true);
    }, timer);
  };

  const onChange = (otp) => {
    setOtp(otp);
    if (otp.length === 6) {
    }
  };

  const attemptStatus = () => {
    dispatch({
      type: LOGGED_IN_SUCCESS,
      data: {
        status: '',
      },
    });
  };

  const goBack = () => {
    setOtp('');
    setCurrentStep(0);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    if (typeof props.mobileChangeStatus === 'function') {
      props.mobileChangeStatus(isUpdated, mobileUpdateStatus);
    }
  };

  const step1 = (
    <div>
      <div className='changeModal_subHeader'>We will send an OTP to your new number.</div>
      <div className='mt_10'>
        Current Number:{' '}
        {`${userDetails.users && userDetails.users.userCountry && userDetails.users.userCountry.phoneCode !== undefined ? '+' + userDetails.users.userCountry.phoneCode : ''} ${
          userDetails.users.mobileNumber
        }`}
      </div>

      <div className='changeModal_inputMargin  countrySelect'>
        <PhoneNumberInput setPhoneNumber={setPhoneNumber} countryCode={userDetails.users && userDetails.users.userCountry && userDetails.users.userCountry.code} />
      </div>
      {showAlert.show ? <Alert message={showAlert.message} type='warning' showIcon className='mt_20' /> : null}
      {mobileError ? <div className='error_text mt_5'>{mobileError}</div> : null}
      <div className='changeModal_buttons'>
        <Button onClick={handleCancel} className='button_default'>
          Cancel
        </Button>
        <Button disabled={showAlert.show || (phoneNumber.nationalNumber && phoneNumber.nationalNumber === '')} onClick={() => checkMobile()} type='primary'>
          Next
        </Button>
      </div>
    </div>
  );

  const step2 = (
    <div className='step2Container'>
      <p className='content_center'>
        We have sent you an <span className='bold_500'>SMS</span> with the OTP to <span className='bold_500'>{phoneNumber.nationalNumber}</span>.{' '}
        <span onClick={() => goBack()} className='link_button pointer'>
          Change Number?
        </span>
      </p>
      <div className='otp_input_box'>
        <OtpInput value={otp} onChange={onChange} shouldAutoFocus numInputs={6} isInputNum={true} />
      </div>
      <p className='content_center'>
        Didn’t receive OTP?{' '}
        {!endTimer ? (
          <span>
            Resend OTP in{' '}
            <span className='link_button'>
              <Timer initialTime={timer} direction='backward'>
                <Timer.Seconds /> seconds
              </Timer>
            </span>
          </span>
        ) : (
          <span
            // onClick={() => { sendOtp() }}
            onClick={sendOtp}
            className='link_button pointer'
          >
            Resend OTP
          </span>
        )}
      </p>
      {authentications && authentications.loggedIn.status === 'BAD_REQUEST' ? <Alert message={authentications.loggedIn.message} type='warning' showIcon className='mt_20' /> : null}
    </div>
  );

  return (
    <ModalBox title='Change Number' visible={isModalVisible} setVisible={setIsModalVisible} className='changeModal' handleCancel={handleCancel}>
      <Steps size='small' current={currentStep}>
        <Step title='Enter New Number' />
        <Step title='Verify OTP' />
      </Steps>
      {currentStep === 0 ? step1 : step2}
    </ModalBox>
  );
}

export default ChangeNumberModal;
